(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-cart-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.querySelector('#aura-cart-panel');
  if (!panel) return;
  const strings = JSON.parse(panel.querySelector('[data-ac-strings]').textContent);
  const ids = {shipping:Number(panel.dataset.shipping),warranty:Number(panel.dataset.warranty)};
  const root = window.Shopify?.routes?.root || '/';
  const money = amount => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(amount/100);
  const api = async (path,body) => {
    const response = await fetch(root+path,body?{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}:{headers:{Accept:'application/json'}});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description||strings.error);
    return data;
  };
  const isService = item => Object.values(ids).includes(item.variant_id);
  const node = (tag,text,cls) => {const element=document.createElement(tag);if(text!==undefined)element.textContent=text;if(cls)element.className=cls;return element;};
  let busy=false;
  async function sync() {
    if (window.AuraGifts) await window.AuraGifts.sync();
    let cart=await api('cart.js');
    const hasGoods=cart.items.some(item=>!isService(item)&&!item.properties?._aura_gift);
    const updates={}, additions=[];
    for (const kind of Object.keys(ids)) {
      if (!ids[kind]) throw new Error(strings.error);
      const preference=cart.attributes['aura_'+kind];
      const lines=cart.items.filter(item=>item.variant_id===ids[kind]);
      const wanted=hasGoods&&(preference==='yes'||(kind==='shipping'&&preference!=='no')||(kind==='warranty'&&preference===undefined&&lines.length>0));
      lines.forEach((item,index)=>{const quantity=wanted&&index===0?1:0;if(item.quantity!==quantity)updates[item.key]=quantity;});
      if(wanted&&!lines.length)additions.push({id:ids[kind],quantity:1,properties:{_aura_service:kind}});
    }
    if(Object.keys(updates).length)await api('cart/update.js',{updates});
    if(additions.length)await api('cart/add.js',{items:additions});
    return api('cart.js');
  }
  function render(cart) {
    const goods=cart.items.filter(item=>!isService(item)).sort((a,b)=>Number(!!a.properties?._aura_gift)-Number(!!b.properties?._aura_gift));
    const content=panel.querySelector('[data-ac-items]');content.replaceChildren();
    panel.querySelector('[data-ac-count]').textContent='('+goods.filter(item=>!item.properties?._aura_gift).reduce((n,item)=>n+item.quantity,0)+')';
    panel.querySelector('[data-ac-footer]').hidden=!goods.length;
    if(!goods.length){const empty=node('div',undefined,'ac-empty');empty.append(node('p',strings.empty));const button=node('button',strings.continue);button.type='button';button.addEventListener('click',()=>panel.close());empty.append(button);content.append(empty);}
    for(const item of goods){
      const row=node('article',undefined,'ac-line');
      if(item.image){const image=node('img');image.src=item.image;image.alt=item.product_title;image.width=76;image.height=76;row.append(image);}else row.append(node('span'));
      const details=node('div');const title=node('h3');const link=node('a',item.product_title);link.href=item.url;title.append(link);details.append(title);
      if(item.variant_title&&item.variant_title!=='Default Title')details.append(node('p',item.variant_title));
      const gift=!!item.properties?._aura_gift;
      details.append(node('div',money(item.final_line_price),'ac-line-price'));
      if(gift)details.append(node('p',item.quantity+' × '+strings.gift,'ac-gift'));
      else {const controls=node('div',undefined,'ac-line-controls');const input=node('input');input.type='number';input.min='1';input.step='1';input.value=item.quantity;input.setAttribute('aria-label',strings.quantity+' — '+item.product_title);input.addEventListener('change',()=>{if(!input.checkValidity()){input.reportValidity();input.value=item.quantity;return;}run(async()=>{await api('cart/change.js',{id:item.key,quantity:Number(input.value)});render(await sync());});});const remove=node('button',strings.remove);remove.type='button';remove.addEventListener('click',()=>run(async()=>{await api('cart/change.js',{id:item.key,quantity:0});render(await sync());}));controls.append(input,remove);details.append(controls);}
      row.append(details);content.append(row);
    }
    for(const checkbox of panel.querySelectorAll('[data-ac-service]'))checkbox.checked=cart.items.some(item=>item.variant_id===ids[checkbox.dataset.acService]);
    panel.querySelector('[data-ac-total]').textContent=money(cart.total_price);
    panel.querySelector('[data-ac-checkout-total]').textContent=money(cart.total_price);
    panel.querySelector('[data-ac-status]').textContent=strings.updated+' '+money(cart.total_price);
    document.querySelectorAll('cart-count').forEach(element=>element.textContent=cart.item_count);
  }
  async function run(action) {
    if(busy)return;busy=true;panel.setAttribute('aria-busy','true');panel.querySelector('[data-ac-error]').hidden=true;
    panel.querySelectorAll('input,button:not([data-ac-close])').forEach(element=>element.disabled=true);
    try{await action();}catch(error){const alert=panel.querySelector('[data-ac-error]');alert.textContent=error.message||strings.error;alert.hidden=false;try{render(await api('cart.js'));}catch{}}
    finally{busy=false;panel.removeAttribute('aria-busy');panel.querySelectorAll('input,button').forEach(element=>element.disabled=false);}
  }
  async function open(){if(!panel.open)panel.showModal();await run(async()=>render(await sync()));}
  window.AuraCart={open};
  panel.querySelector('[data-ac-close]').addEventListener('click',()=>panel.close());
  panel.addEventListener('click',event=>{if(event.target===panel){const box=panel.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right)panel.close();}});
  panel.querySelectorAll('[data-ac-service]').forEach(checkbox=>checkbox.addEventListener('change',()=>run(async()=>{await api('cart/update.js',{attributes:{['aura_'+checkbox.dataset.acService]:checkbox.checked?'yes':'no'}});render(await sync());})));
  panel.querySelector('[data-ac-checkout]').addEventListener('click',()=>run(async()=>{const cart=await sync();render(cart);if(!cart.items.some(item=>!isService(item)&&!item.properties?._aura_gift))return;if(cart.items.some(item=>item.properties?._aura_gift&&item.final_line_price>0))throw new Error(strings.error);location.assign(root+'checkout');}));
  if(location.pathname===root+'cart')open();
})();
  } catch(e) { console.error(e); }
})();

})();
